import { Button } from "@fieldwork/ui/components/button";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";

import { checkSession } from "@/lib/auth-client";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if ((await checkSession()).state === "signed-in") throw redirect({ to: "/servers" });
  },
  component: Home,
});

function Home() {
  return (
    <div className="mx-auto mt-16 w-full max-w-2xl px-4 text-sm leading-relaxed">
      <h1 className="mb-4 text-2xl font-semibold tracking-tight">Your own task assistant, on your own server.</h1>
      <p className="mb-3 text-muted-foreground">
        Fieldwork sets itself up on a server in <em>your</em> cloud account. It reads your email, Slack,
        Telegram, GitHub and Notion, and keeps a task tracker (Plane) up to date with what people ask of you.
      </p>
      <p className="mb-6 text-muted-foreground">
        Your messages, tokens and API keys stay on that server. The server connects out to this panel; it opens no ports.
      </p>
      <Link to="/login">
        <Button>Sign in or request access</Button>
      </Link>
    </div>
  );
}
